import { SolanaWallet } from "../../core/types/wallet";
import { filterSolanaWallets } from "../../services/internal/solanaService";
import { useStandardWallets } from "../wallet/useStandardWallets";

export function useSolanaWallets(): { wallets: SolanaWallet[] } {
  return useStandardWallets<SolanaWallet>({
    filterWallets: filterSolanaWallets,
  });
}
